import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import "./BillingSummary.scss";
import { updateBillingLaywers } from "../../store/actions/billingAction";


import {
    TextField
} from '@material-ui/core';

let tick = "/img/tick.svg";

const BillingSummary = (props) => {
    const { modalPayments, billing, updateBillingLaywers, laywerUid, role } = props

    let membershipBenefitPremium = [
        { textOne: "Posicionamiento y presencia Online dentro y fuera", textTwo: "de la plataforma.", index: 0 },
        { textOne: "Sitio web con dominio personalizadoy branding de abogado.", index: 1 },
        { textOne: "Publicación de artículos/investigaciones", textTwo: "de su materia de especialidad.", index: 2 },
        /* { textOne: "Chat directo ", textTwo: "con los clientes.", index: 3 } */
    ]

    let membershipBenefitPremiumPlus = [
        { textOne: "Perfil profesional ", textTwo: "completo y público", index: 0 },
        { textOne: "El mejor posicionamiento en listados de búsqueda. ", textTwo: "", index: 1 },
        { textOne: "Distintivo Premium Plus ", textTwo: "dentro de los listados.", index: 2 },
        { textOne: "Perfil abogado Premium para el titular ", textTwo: "del despacho", index: 3 }
    ]

    

    useEffect(() => {
    }, []);

    const handleEditBilling = () => {
        let data = {
            ...billing,
            billingForm: false
        }

        updateBillingLaywers(laywerUid, data)
    }

    const getPrice = (val) =>{
        let valueString = val.replace(',','');
        console.log(valueString)
        let value = parseFloat(valueString)
        console.log(value)
         let resp = value+(16 / 100 * value)
         return  resp.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    return (
        <div className="contentMainBillingSummary">
            <p className="titleSummary">Tu resumen de compra</p>
            <div className="contentDataMembershipSummary">
                <div className="contentSpaceM">
                    <p className="subTitleSummary">Membresía <span className="typeMembershipSummary">{ modalPayments &&  modalPayments.membershipRole === "lawyer" ? "ABOGADO" : "DESPACHO"} PREMIUM </span></p>
                    <p className="permanenceMembership">Permanencia mínima de {modalPayments &&  modalPayments.typePayment === "sixMonths"  ? '6 meses': '12 meses' }</p>
                </div>
                <div className="contentSpaceM">
                    <p className="priceMembershipSummary">{modalPayments.cost}.-<span className="typeCurrency">MXN</span> </p>
    <p className="taxesTextMembership">Incluye IVA/inversión {modalPayments && modalPayments.typePayment === "twelveMonths" ||  modalPayments.typePayment === "sixMonths"  ? 'mensual': 'anual' }</p>
                </div>

            </div>
            {membershipBenefitPremium.map((text) => {
                return (
                    <div key={text.index} className="contentDataTypeMembership">
                        <p className="textProfessionalProfile"><span className="profileMembership">{text.textOne}</span>{text.textTwo}</p>
                        <img src={tick} />
                    </div>
                )
            })}

            

            {billing && billing.billingForm === true && 
                <div className="contentDataBillingEdit">
                    <div className="contentTitleDataBilling">
                        <p className="titleSummary">Datos de facturación</p>
                        <p onClick={handleEditBilling} className="editDataBilling">Editar datos</p>
                    </div>
                    <p className="nameLaywerBillingEdit">Nombre del abogado o despacho</p>
                    <p className="dataLaywerBillingEdit">{billing.nameLawyerOrLawFirm}</p>
                    <div className="contentTitleDataBilling">
                        <div className="contentSizeBillingEdit">
                            <p className="nameLaywerBillingEdit">RFC</p>
                            <p className="dataLaywerBillingEdit">{billing.rfc}</p>
                        </div>
                        <div className="contentSizeBillingEdit">
                            <p className="nameLaywerBillingEdit">Correo electrónico</p>
                            <p className="dataLaywerBillingEdit">{billing.invoiceEmail}</p>
                        </div>
                    </div>
                    <div className="contentTitleDataBilling">
                        <div className="contentSizeBillingEdit">
                            <p className="nameLaywerBillingEdit">Número telefónico</p>
                            <p className="dataLaywerBillingEdit">{billing.invoicePhoneNumber}</p>
                        </div>
                        {billing && billing.zipCode && billing.zipCode != '' ? <>
                        <div className="contentSizeBillingEdit">
                            <p className="nameLaywerBillingEdit">País</p>
                            <p className="dataLaywerBillingEdit">{billing.country}</p>
                        </div>
                        </> : null}
                    </div>
                    {billing && billing.zipCode && billing.zipCode != '' ? <>

                    <div className="contentTitleDataBilling">
                        <div className="contentSizeBillingEdit">
                            <p className="nameLaywerBillingEdit">Código postal</p>
                            <p className="dataLaywerBillingEdit">{billing.zipCode}</p>
                        </div>
                        <div className="contentSizeBillingEdit">
                            <p className="nameLaywerBillingEdit">Estado</p>
                            <p className="dataLaywerBillingEdit">{billing.states}</p>
                        </div>
                    </div>
                    <div className="contentTitleDataBilling">
                        <div className="contentSizeBillingEdit">
                            <p className="nameLaywerBillingEdit">Ciudad</p>
                            <p className="dataLaywerBillingEdit">{billing.city}</p>
                        </div>
                        <div className="contentSizeBillingEdit">
                            <p className="nameLaywerBillingEdit">Colonia</p>
                            <p className="dataLaywerBillingEdit">{billing.neighborhood}</p>
                        </div>
                    </div>
                    <div className="contentTitleDataBilling">
                        <div className="contentSizeBillingEdit">
                            <p className="nameLaywerBillingEdit">Calle</p>
                            <p className="dataLaywerBillingEdit">{billing.street}</p>
                        </div>
                        <div className="contentSizeBillingEdit">
                            <p className="nameLaywerBillingEdit">Número</p>
                            <p className="dataLaywerBillingEdit">{billing.outdoorNumber}</p>
                        </div>
                    </div>
                    </> : null}

                    <div className="contentTitleDataBilling">
                        <div className="contentSizeBillingEdit">
                            <p className="nameLaywerBillingEdit">Uso de CFDI</p>
                            <p className="dataLaywerBillingEdit">{billing.cfdi && billing.cfdi.description}</p>
                        </div>
                    </div>
                </div>}

        </div>
    );
};

const mapDispatchToProps = dispatch => ({
    updateBillingLaywers: (laywerUid, data) => dispatch(updateBillingLaywers(laywerUid, data)),
})

const mapStateToProps = (state) => ({
    modalPayments: state.ModalReducer.openModalPayments,
    billing: state.billingReducer.billingData,
    laywerUid: state.authClient.uid,
    role: state.authClient.role,
});

export default connect(mapStateToProps, mapDispatchToProps)(BillingSummary);